import React, { useEffect, useState } from 'react'
import {
    HiCheckCircle,
    HiOutlineInformationCircle,
    HiOutlineExclamation,
    HiOutlineExclamationCircle
} from 'react-icons/hi'
import { Avatar, Dialog, Notification, toast, } from 'components/ui'
import PropTypes from 'prop-types'
import { MdRestore } from 'react-icons/md'
import ConfirmDialog from './ConfirmDialog'
import { useDispatch, useSelector } from 'react-redux'
import { getPackageHistoryList, getPackages, restorePackageVersion } from 'views/eywafarm/CropCycle/store/packages'
import { useParams } from 'react-router-dom'
import moment from 'moment'

const StatusIcon = ({ status }) => {

    switch (status) {
        case 'info':
            return (
                <Avatar className="bg-blue-100 text-blue-600 dark:bg-blue-500/20 dark:text-blue-100" shape="circle">
                    <span className="text-2xl"><HiOutlineInformationCircle /></span>
                </Avatar>
            )
        case 'success':
            return (
                <Avatar className="bg-emerald-100 text-emerald-600 dark:bg-emerald-500/20 dark:text-emerald-100" shape="circle">
                    <span className="text-2xl"><HiCheckCircle /></span>
                </Avatar>
            )
        case 'warning':
            return (
                <Avatar className="text-amber-600 bg-amber-100 dark:text-amber-100" shape="circle">
                    <span className="text-2xl"><HiOutlineExclamationCircle /></span>
                </Avatar>
            )
        case 'danger':
            return (
                <Avatar className="text-red-600 bg-red-100 dark:text-red-100" shape="circle">
                    <span className="text-2xl"><HiOutlineExclamation /></span>
                </Avatar>
            )

        default:
            return null
    }
}

const HistoryDialog = props => {

    const {
        type,
        title,
        children,
        onCancel,
        packageID,
        draft_packageID,
        confirmButtonColor,
        onRevertSuccess,
        ...rest
    } = props

    const dispatch = useDispatch();
    const params = useParams();
    const [versionName, setVersionName] = useState('');
    const [isDialogOpen, setIsDialogOpen] = useState(false);

    const {
        historyList,
        currentPartner
    } = useSelector((state) => ({
        historyList: state.cropCycles.packages.packageHistoryList,
        currentPartner: state.auth.partner.id,
    }))

    const hanldeOpenConfirmDialog = (version) => {
        if (version?.fileName) {
            setIsDialogOpen(true)
            setVersionName(version?.fileName)
        }
    }

    const handleRestoreVersion = () => {

        let reqData = {
            version: versionName,
            packageId: packageID,
            draftPackageId: draft_packageID,
        }

        if (reqData?.draftPackageId) {
            restorePackageVersion(reqData, (res) => {
                dispatch(getPackages(({ id: params?.id, subId: '', partner: currentPartner })))
                setIsDialogOpen(false)
                onRevertSuccess()
                toast.push(
                    <Notification title={"Success"} type="success" duration={3000}>
                        Package Restored !
                    </Notification>, {
                    placement: 'bottom-end'
                })
            }, (err) => {
                setIsDialogOpen(false)
                toast.push(
                    <Notification title={"Error"} type="danger" duration={3000}>
                        {err?.message}
                    </Notification>, {
                    placement: 'bottom-end'
                })
            }
            )
        }
    }

    useEffect(() => {
        dispatch(getPackageHistoryList({ draftPackageId: draft_packageID, packageId: packageID }))
    }, [])

    return (
        <Dialog
            style={{
                marginTop: 250,
            }}
            contentClassName="pb-0 px-0"
            {...rest}
        >
            <div className="px-6 pb-6 pt-2 flex">
                <div>
                    <StatusIcon status={type} />
                </div>
                <div className="ml-4 rtl:mr-4">
                    <h5 className="mb-2">{title}</h5>
                </div>
            </div>
            <div className="">
                <div className='h-96  p-10 overflow-x-scroll'>
                    {historyList && historyList?.length ?
                        historyList?.map((item, ind) => {
                            return (
                                <div key={ind} className='flex flex-row justify-between bg-slate-300 p-2 mb-1'>
                                    <p>{item?.fileName.substring(11, 19)}</p>
                                    <p>{moment(item?.createdAt).format("DD-MM-YYYY - hh:mm a")}</p>
                                    <div>
                                        <button
                                            onClick={() => hanldeOpenConfirmDialog(item)}
                                            title={'Revert'}
                                            className={'text-blue-700'}
                                        >
                                            <MdRestore className='w-5 h-5' />
                                        </button>
                                    </div>
                                </div>
                            )
                        })
                        : null
                    }
                </div>
                {children}
            </div>

            {isDialogOpen &&
                <ConfirmDialog
                    isOpen={isDialogOpen}
                    type='danger'
                    title={'Are you sure! do you really want to restore this version of the package? It will erase all the current changes.'}
                    onConfirm={handleRestoreVersion}
                    onCancel={() => setIsDialogOpen(false)}
                    onClose={() => setIsDialogOpen(false)}
                />
            }
        </Dialog>
    )
}

HistoryDialog.propTypes = {
    type: PropTypes.oneOf(['info', 'success', 'warning', 'danger']),
}

export default HistoryDialog
